import {Store} from 'redux';
import {MiranaServiceClient} from '../middleware/mirana-client';
import myCreateStore from '../reduxstore/create-store';
import {container, TYPES} from './inversify-config';
import MiranaState from '../reduxstore/mirana-state';
import AppAction from '../reduxstore/actions/action';


const store = myCreateStore();
container.bind<Store<MiranaState, AppAction>>(TYPES.REDUX_STORE).toConstantValue(store);

if (!container.isBound(TYPES.MIRANA_SERVICE)) {
    container.bind<MiranaServiceClient>(TYPES.MIRANA_SERVICE).to(MiranaServiceClient).inSingletonScope();
}



// WEBPACK FOOTER //
// ./src/utils/container-bootstrap.ts